export default {
  airt: {
    0: '0',
    20: '20',
  },
  airh: {
    0: '0',
    50: '50',
    75: '75',
  },
  illu: {
    0: '0',
    50: '100',
    175: '175',
  },
  co2: {
    0: '0',
    1000: '1000',
    1700: '1700',
  },
  soilt: {
    0: '0',
    20: '20',
  },
  soilh: {
    0: '0',
    50: '50',
    75: '75',
  },
  adh: {
    0: '0',
    500: '500',
    750: '750',
  },
  par: {
    0: '0',
    2000: '2000',
    5000: '5000',
  },
}



// WEBPACK FOOTER //
// ./src/components/plant/programme/scheme-slider-marks.js